<script setup>
import { defineEmits, defineProps } from 'vue';
import Icon from '../../miscellaneous/Icon.vue';

const props = defineProps({
    scope: {
        type: String,
        default: 'slider'
    },
    images: {
        type: Array,
        required: true
    },
    activeSliderIndex: {
        type: Number,
        default: 0
    },
    tabContent: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['toggleFullscreen', 'changeActiveTab', 'slideToImage', 'changeActiveTabFromIndicator']);

const toggleFullscreen = () => {
    emit('toggleFullscreen', true, props.scope);
};

const changeActiveTab = (item, index) => {
    emit('changeActiveTabFromIndicator', item, index);
};
const slideToImage = (index) => {
    emit('slideToImage', index);
};
const slideToTab = (item) => {
    const hasImageValue = props.images.findIndex((image) => image.key === item?.key);
    slideToImage(hasImageValue !== -1 ? hasImageValue : 0);
    const getFirstName = props.tabContent.findIndex((pos) => {
        const tabTitle = pos.attributes.title.de;
        const itemTitle = item?.attributes.title.de;

        return itemTitle?.includes(tabTitle);
    });

    emit('changeActiveTab', item, getFirstName);
};
</script>

<template>
    <div class="relative">
        <!-- Image Slider -->

        <div class="overflow-x-hidden" :class="`image-${scope}`">
            <div class="relative swiper-wrapper">
                <div v-for="item in images" :key="item.id" class="swiper-slide" @click="toggleFullscreen(item.attributes.image)">
                    <div class="z-30 w-8 h-8 flex items-center justify-center rounded-xl bg-white text-gray-900 absolute top-4 right-4 cursor-pointer">
                        <Icon type="Scale" viewBox="0 0 19 18" width="14" height="14" class="fill-current" />
                    </div>
                    <img class="rounded prevent-click" :src="item.attributes.image" alt="slider-image" />
                </div>
            </div>
        </div>

        <!-- Image Title Click -->
        <div class="flex max-w-full gap-2 p-2 mx-auto overflow-x-auto bg-white w-fit overflow-y-clip">
            <button
                v-for="(item, index) in images"
                :key="item.id"
                :class="index === activeSliderIndex ? 'bg-blue text-white' : 'text-blue hover:scale-105 hover:shadow-md duration-300'"
                class="p-2 border rounded-md shadow-md border-blue whitespace-nowrap"
                @click="scope === 'indicator' ? changeActiveTab(item, index) : slideToTab(item)"
            >
                {{ $translate(item.attributes.title) }}
            </button>
        </div>
    </div>
</template>
